/**
 * @generated SignedSource<<850f77725d5494c38ccd4133cb0d0680>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type TaskStatusEnum = "deactivated" | "error_report" | "first_labeling" | "image_creation" | "problem_creation" | "problem_typing" | "published" | "review" | "second_labeling" | "%future added value";
export type AssignedTaskStatusTabList_assignedTaskStatusCountsQuery$variables = {};
export type AssignedTaskStatusTabList_assignedTaskStatusCountsQuery$data = {
  readonly assignedTaskStatusCounts: ReadonlyArray<{
    readonly count: number;
    readonly status: TaskStatusEnum;
  }>;
};
export type AssignedTaskStatusTabList_assignedTaskStatusCountsQuery = {
  response: AssignedTaskStatusTabList_assignedTaskStatusCountsQuery$data;
  variables: AssignedTaskStatusTabList_assignedTaskStatusCountsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "TaskStatusCount",
    "kind": "LinkedField",
    "name": "assignedTaskStatusCounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "count",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignedTaskStatusTabList_assignedTaskStatusCountsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AssignedTaskStatusTabList_assignedTaskStatusCountsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "6256b97dc492dba00261ad5711735d44",
    "id": null,
    "metadata": {},
    "name": "AssignedTaskStatusTabList_assignedTaskStatusCountsQuery",
    "operationKind": "query",
    "text": "query AssignedTaskStatusTabList_assignedTaskStatusCountsQuery {\n  assignedTaskStatusCounts {\n    count\n    status\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ab5a99fc1c622b76697e27f9a8155ea";

export default node;
